import axios from "axios";
import Vue from "vue";
import apiClient from "@/services/axios";
import { i18n } from "@/localization";

/**
 * @param {import('axios').AxiosError} error
 */
function showPresignUploadError(error) {
  const data = error.response && error.response.data;
  let description = i18n.t("errorCode.UPLOAD_PRESIGN_FAILED");

  if (data) {
    const code = data.errorCode;
    if (code && i18n.te(`errorCode.${code}`)) {
      description = i18n.t(`errorCode.${code}`);
    }
  }

  Vue.prototype.$notification.warning({
    message: i18n.t("upload.failedTitle"),
    description,
  });
}

export async function uploadFilesToS3(
  filesToUpload,
  group,
  progressBar,
  dbName = null
) {
  const filesData = {
    files: filesToUpload.map((file) => ({
      fileName: file.name,
      fileType: file.type,
      size: typeof file.size === "number" ? file.size : 0,
    })),
    group: group,
  };

  if (dbName) {
    filesData.dbName = dbName;
  }

  const uploadProgress = new Array(filesToUpload.length).fill(0);

  try {
    // Step 1: Get pre-signed URLs from backend
    const res = await apiClient.post("/aws/upload/presignedurls", filesData);
    const uploadKeys = res.data; // Array of { url, key, type }

    // Step 2: Upload each file to S3
    await Promise.all(
      uploadKeys.map(({ url, type }, index) =>
        axios.put(url, filesToUpload[index], {
          headers: { "Content-Type": type },
          onUploadProgress: (progressEvent) => {
            const progress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
            uploadProgress[index] = progress;

            const totalProgress = uploadProgress.reduce((sum, p) => sum + p, 0);
            progressBar.value = Math.round(totalProgress / uploadKeys.length);
          },
        })
      )
    );

    return uploadKeys.map((e) => e.key); // Return uploaded file keys
  } catch (error) {
    console.error("Upload failed:", error);
    showPresignUploadError(error);
    throw error;
  }
}
